import React from 'react';
import Link from 'gatsby-link';

import Footer from '../components/Footer';
import Helmet from '../components/Helmet';
import Title from '../components/Title';
import { rhythm } from '../utils/typography';

const TitleLink = (props) => <Link {...props} style={{ color: 'black' }} />;

export default class IndexPageTemplate extends React.Component {
  render() {
    const siteTitle = this.props.data.site.siteMetadata.title;
    const posts = this.props.data.allMarkdownRemark.edges;
    const { currentPage, hasMorePrevious, hasMoreRecent } = this.props.pathContext;

    return (
      <div>
        <Helmet title={siteTitle}>
          <link rel="canonical" href={`https://desiatov.com`} />
          <meta
            name="description"
            content={`I'm Max Desiatov, I co-maintain WebAssembly support for Swift and a framework \
            called Tokamak compatible with SwiftUI.`}
          />
          <meta
            property="og:description"
            content={`I'm Max Desiatov, I co-maintain WebAssembly support for Swift and a framework \
            called Tokamak compatible with SwiftUI.`}
          />
          <meta property="og:url" content="https://desiatov.com" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:description"
            content={`I'm Max Desiatov, I co-maintain WebAssembly support for Swift and a framework \
            called Tokamak compatible with SwiftUI.`}
          />
          <meta name="twitter:title" content={siteTitle} />
        </Helmet>
        {posts.map(({ node }) => {
          const title = node.frontmatter.title || node.fields.slug;
          return (
            <div key={node.fields.slug}>
              <Title>
                <TitleLink name="index-title" to={`${node.fields.slug}#title`}>
                  {title}
                </TitleLink>
              </Title>
              <small
                style={{
                  display: 'block',
                  marginBottom: rhythm(1),
                }}
              >
                {node.frontmatter.date}
              </small>
              {node.frontmatter.topImg && (
                <Link to={`${node.fields.slug}#title`} style={{ boxShadow: 'none' }}>
                  <img
                    style={{
                      float: 'right',
                      maxWidth: '40%',
                      marginLeft: rhythm(0.5),
                    }}
                    src={node.frontmatter.topImg.publicURL}
                  />
                </Link>
              )}
              {node.frontmatter.tldr && (
                <p dangerouslySetInnerHTML={{ __html: node.frontmatter.tldr }} />
              )}
              <h3 style={{ marginTop: rhythm(1), marginBottom: rhythm(3) }}>
                <Link to={`${node.fields.slug}#title`}>Read more...</Link>
              </h3>
            </div>
          );
        })}
        {hasMorePrevious && (
          <Link to={`/page/${currentPage + 1}#index-title`} rel="prev" style={{ float: 'left' }}>
            ← More previous articles
          </Link>
        )}
        {hasMoreRecent && (
          <Link
            to={currentPage - 1 === 0 ? '/#index-title' : `/page/${currentPage - 1}#index-title`}
            rel="next"
            style={{ float: 'right' }}
          >
            More recent articles →
          </Link>
        )}
        <Footer />
      </div>
    );
  }
}

export const pageQuery = graphql`
  query IndexPageQuery($skip: Int, $limit: Int) {
    site {
      siteMetadata {
        title
      }
    }

    allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { isDraft: { ne: true } } }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            date(formatString: "DD MMMM, YYYY")
            title
            tldr
            topImg {
              publicURL
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/IndexPage.js